import { createElementVNode as _createElementVNode, vModelText as _vModelText, withDirectives as _withDirectives, withModifiers as _withModifiers, renderList as _renderList, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock, toDisplayString as _toDisplayString, createCommentVNode as _createCommentVNode } from "vue"

const _hoisted_1 = { class: "nes-container with-title" }
const _hoisted_2 = /*#__PURE__*/_createElementVNode("p", { class: "title" }, "Authorize / Deauthorize Funders", -1)
const _hoisted_3 = { class: "flex" }
const _hoisted_4 = { class: "nes-field mb-5" }
const _hoisted_5 = /*#__PURE__*/_createElementVNode("label", { for: "authorizeFunder" }, null, -1)
const _hoisted_6 = /*#__PURE__*/_createElementVNode("button", { class: "nes-btn is-primary mb-5" }, "Authorize", -1)
const _hoisted_7 = { class: "nes-field mb-5" }
const _hoisted_8 = /*#__PURE__*/_createElementVNode("label", { for: "deauthorizeFunder" }, null, -1)
const _hoisted_9 = /*#__PURE__*/_createElementVNode("button", { class: "nes-btn is-primary mb-5" }, "Deauthorize", -1)
const _hoisted_10 = {
  key: 0,
  class: "mb-5"
}
const _hoisted_11 = /*#__PURE__*/_createElementVNode("p", { class: "mb-2" }, "Authorized funders:", -1)

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _hoisted_2,
    _createElementVNode("div", _hoisted_3, [
      _createElementVNode("form", {
        class: "mr-5 flex-1",
        onSubmit: _cache[1] || (_cache[1] = _withModifiers(
//@ts-ignore
(...args) => (_ctx.authorizeFunder && _ctx.authorizeFunder(...args)), ["prevent"]))
      }, [
        _createElementVNode("div", _hoisted_4, [
          _hoisted_5,
          _withDirectives(_createElementVNode("input", {
            id: "authorizeFunder",
            class: "nes-input",
            "onUpdate:modelValue": _cache[0] || (_cache[0] = ($event: any) => ((_ctx.toAuthorize) = $event))
          }, null, 512), [
            [_vModelText, _ctx.toAuthorize]
          ])
        ]),
        _hoisted_6
      ], 32),
      _createElementVNode("form", {
        class: "flex-1",
        onSubmit: _cache[3] || (_cache[3] = _withModifiers(
//@ts-ignore
(...args) => (_ctx.deauthorizeFunder && _ctx.deauthorizeFunder(...args)), ["prevent"]))
      }, [
        _createElementVNode("div", _hoisted_7, [
          _hoisted_8,
          _withDirectives(_createElementVNode("input", {
            id: "deauthorizeFunder",
            class: "nes-input",
            "onUpdate:modelValue": _cache[2] || (_cache[2] = ($event: any) => ((_ctx.toDeauthorize) = $event))
          }, null, 512), [
            [_vModelText, _ctx.toDeauthorize]
          ])
        ]),
        _hoisted_9
      ], 32)
    ]),
    (_ctx.funders && _ctx.funders.length)
      ? (_openBlock(), _createElementBlock("div", _hoisted_10, [
          _hoisted_11,
          (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.funders, (f) => {
            return (_openBlock(), _createElementBlock("div", {
              key: f.publicKey.toBase58()
            }, _toDisplayString(f.account.authorizedFunder.toBase58()), 1))
          }), 128))
        ]))
      : _createCommentVNode("", true)
  ]))
}